// src/urlHash.ts
import qs from "query-string";

/** Sätter/ersätter enstaka query-param i hash-delen (#/path?query). */
export function setHashQueryParam(key: string, value: string | number | boolean) {
  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;

  const [path, search = ""] = hash.split("?");
  const q = qs.parse(search);
  q[key] = String(value);

  const nextSearch = qs.stringify(q, { skipNull: true, skipEmptyString: true });
  window.location.hash = nextSearch ? `${path}?${nextSearch}` : path;
}

/** Tar bort en query-param ur hash-delen. */
export function deleteHashQueryParam(key: string) {
  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;

  const [path, search = ""] = hash.split("?");
  const q = qs.parse(search);
  delete q[key];

  const nextSearch = qs.stringify(q, { skipNull: true, skipEmptyString: true });
  window.location.hash = nextSearch ? `${path}?${nextSearch}` : path;
}
